import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FORMA_EXPORTACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    FORMA_EXPORTACAO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    FORMA_EXPORTACAO_ENDPOINT,
    id
  ]);
}
